import './jsonViewer';
import './axios';
import './chartist';
import './vuetify';
import { register as registerMatomo } from './matomo';

export function registerPlugins(router) {
  registerMatomo(router);
}
